module.exports = __webpack_public_path__ + "img/boy-cup.2428235d.svg";